import ApiCore from './api-core'

export default class ApiBase extends ApiCore {
  report(filter, showProgress) {
    return this._request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  create(model, showProgress) {
    return this._request({
      action: 'create',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  update(id, model, showProgress) {
    return this._request({
      action: id,
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  getById(id, showProgress) {
    return this._request({
      action: id,
      method: 'GET',
      showProgress
    })
  }

  get(filter, showProgress) {
    return this._request({
      action: 'get',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  delete(id, showProgress) {
    return this._request({
      action: id,
      method: 'DELETE',
      showProgress
    })
  }

  count(filter, showProgress) {
    return this._request({
      action: 'count',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  list(filter, showProgress) {
    return this._request({
      action: 'list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  enable(id, showProgress) {
    return this._request({
      action: `${id}/enable`,
      method: 'PATCH',
      showProgress
    })
  }

  disable(id, showProgress) {
    return this._request({
      action: `${id}/disable`,
      method: 'PATCH',
      showProgress
    })
  }

  import(model, showProgress) {
    return this._request({
      action: 'import',
      method: 'POST',
      body: model,
      showProgress
    })
  }

  export(params, showProgress) {
    return this._request({
      action: 'export',
      method: 'GET',
      params,
      showProgress
    })
  }
}
